/**
 * Public Route Component
 * Redirects authenticated users away from auth pages
 */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '@/shared/constants';

interface PublicRouteProps {
  children: ReactNode;
}

/**
 * Public route wrapper
 * Redirects to dashboard if already authenticated
 */
export function PublicRoute({ children }: PublicRouteProps) {
  // TODO: Replace with actual auth check from auth context/store
  const isAuthenticated = false;

  if (isAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <>{children}</>;
}
